import React from 'react'
import useCurrentUser from './hooks/use-current-user'
import useRefreshToken from './hooks/use-refresh-token'
import { useHostedExbInfo } from './hooks/use-tenant-configs'
import ApiClient from './lib/api-client'

const defaultAppData = {
  token: null,
  currentUser: null
}

export const AppDataContext = React.createContext(defaultAppData)

const AppDataProvider = ({ children }) => {
  const enabled = ApiClient.hasToken
  const { data, isLoading } = useCurrentUser({ enabled })
  useRefreshToken({ enabled })
  const currentUser = ApiClient.hasToken ? data : null
  useHostedExbInfo({ tenantId: currentUser?.tenantId, role: currentUser?.role })
  return (
    <AppDataContext.Provider value={{
      currentUser,
      isLoading,
      hasToken: ApiClient.hasToken
    }}
    >
      {children}
    </AppDataContext.Provider>
  )
}

export default AppDataProvider
